import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const ZipcodeProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();
    
    const listStatisticByState = useCallback(async (props) => {
        await execute({ scope: 'listStatisticByState', url: `ZipCode/ZipCodeStatisticsByStates/?id=${props.states}`, method: 'GET', secure: true });
    }, [execute]);

    const value = { listStatisticByState, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useZipcodeStore = () => React.useContext(Context);
